import type { DeepPartial } from '@luna/utils-ts';

import type { Overview } from '../../types/Overview';

export const overviewHRFeatureConfig: DeepPartial<Overview> = {
    applyPositionsForTitleCount: true,
    getSumPerTypeTotalMarketValue: true,
    hideFilterSecurityType: true,
    sortAttribute: '-marketValue',
    stockValueTooltip: true,
    sumValueFromPositions: true,
    totalMarketValueFromPositions: true,
};
